import { Link } from "@tanstack/react-router";

function NotFound() {
	return (
		<div className="container h-full w-full flex flex-col justify-center items-center gap-2 bg-gradient-account">
			<h1 className="text-5xl font-bold text-white">404</h1>
			<p className="text-xl font-semibold text-white">Page not found</p>
			<Link
				to="/"
				preload={false}
				className="bg-primary py-4 px-6 rounded-full text-white font-semibold hover:bg-primary/70 uppercase"
			>
				Back to Home
			</Link>
		</div>
	);
}

export default NotFound;
